import React from 'react';
import { FormattingOptionItem } from '../../../concepts/text/FormattingOptionItem';
import { Text } from '../../packages/text/Text';
import { RenderBounds, RenderInner, usePose } from './RenderHelpers';
import { RenderText } from './RenderText';

export const TextVisual = ({ object }: { object: Text }) => {

    const { layout } = object;
    const { beingEdited } = usePose(object);

    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                {!beingEdited && <RenderText {...layout.content} value={object.content} formatOpts={FormattingOptionItem.defaults} />}
            </RenderInner>
        </RenderBounds>
    </>;
};
